import { SET_LOADER_STATE } from "./loader.types";

export const setLoader = (loaderState) => {
  ;
  return {
    type: SET_LOADER_STATE,
    loaderState,
  };
};
